import { Link } from 'react-router-dom';
import { getNestedValue } from '@/lib/screen-utils';
import type { CellRendererProps } from './index';

export function IdCell({ value, row, config }: CellRendererProps) {
  const prefix = (config?.prefix as string) ?? '';
  const subtitleField = config?.subtitleField as string | undefined;
  const linkPath = config?.linkPath as string | undefined;

  const displayValue = `${prefix}${value ?? ''}`;
  const subtitleRaw = subtitleField ? getNestedValue(row, subtitleField) : null;
  const subtitle = subtitleRaw ? String(subtitleRaw) : null;

  // Resolve linkPath by replacing all :id tokens with the row's id
  const rowId = (row as Record<string, unknown>).id;
  const href = linkPath && rowId != null
    ? linkPath.replace(/:id/g, String(rowId))
    : undefined;

  return (
    <div>
      {href ? (
        <Link to={href} className="font-medium text-primary hover:underline font-mono text-sm">
          {displayValue}
        </Link>
      ) : (
        <span className="font-medium font-mono text-sm">{displayValue}</span>
      )}
      {subtitle && (
        <p className="text-sm text-muted-foreground truncate max-w-xs">
          {subtitle}
        </p>
      )}
    </div>
  );
}
